import { TCustomCell } from "components/Category/Category";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import ReactDOM from "react-dom";

type Props<T> = {
  customRowCells: { [k in keyof T]?: TCustomCell<T> | undefined };
  row: { [K in keyof T]: React.ReactNode };
  k: string;
  id: string;
  setCustomCellValue?: React.Dispatch<any>;
  customCellValue?: any;
  refs?: { selectRef?: any; containerRef?: any };
  parentSelectedId?: number;
};
export const ProgressBarCell = <T extends { [K: string]: React.ReactNode }>(
  props: Props<T>
) => {
  const {
    row,
    customRowCells,
    k,
    id,
    customCellValue,
    setCustomCellValue,
    refs,
    parentSelectedId,
  } = props;
  const selectOptions =
    (row[customRowCells[k]?.dataSource as keyof T] as any[]) ?? [];

  const cellValue = customCellValue?.find(
    (r: any) => r.id.toString() === id.toString()
  ) as any;

  const finalValue =
    typeof cellValue === "object" && cellValue.hasOwnProperty(k)
      ? cellValue[k]
      : null;

  let progressBarPercentage: number | null = null;

  if (finalValue && typeof finalValue === "string") {
    const splitValue = finalValue.split("/");
    if (splitValue.length === 2) {
      try {
        const firstNumber = parseInt(splitValue[0]);
        const lastNumber = parseInt(splitValue[1]);

        progressBarPercentage = (firstNumber / lastNumber) * 100;
      } catch {
        console.log("Failed to parse progress bar data");
      }
    }
  }

  return (
    <>
      {/* <div
        onClick={event => {
          event.stopPropagation();
        }}
        id={`${k}-${id}`}
        // className={`${k}-${row[k]}---${
        //   customCellValue?.find((r: any) => r.id === id)[k]
        // }`}
        style={{ position: "relative" }}
      > */}
      <div className="ProgressBarCell">
        <div
          className={`Background ${parseInt(id) % 2 === 0 ? "Even" : "Odd"}`}
        >
          <div
            className={`Bar ${progressBarPercentage === 100 ? "Complete" : ""}`}
            style={{ width: `${progressBarPercentage}%` }}
          ></div>
        </div>

        <div className="Text">{finalValue ?? "-"}</div>
      </div>
      {/* </div> */}
    </>
  );
};
